export default {
    workspaceId(state) {
        return state.user.registeredWorkspaces.filter(x => x.isCurrentWorkspace)[0]?.id;
    },
    workspaceIdForHeader(state) {
        return state.user.registeredWorkspaces.filter(x => x.isCurrentWorkspace)[0]?.headerId;
    },
    isBrandSentimentAvailable(state) {
        return !!state.user.registeredWorkspaces.filter(x => x.isCurrentWorkspace)[0]?.isBrandSentimentAvailable;    
    },
    registeredWorkspces(state) {
        return state.user.registeredWorkspaces;
    },
    registeredWorkspcesForSelect(state) {
        return state.user.registeredWorkspaces.map((workspace) => ({
          id: workspace.headerId,
          text:workspace.name,
        }));
    },
    uiPermissions(state) {
        return state.user.uiPermissions;
    },
    activeWorkspaceSources(state) {
        return state.user.activeWorkspaceSources;
    },
    isHierarchic(state) {
        const currentWorkspace = state.user.registeredWorkspaces.filter(x => x.isCurrentWorkspace)[0];
        const operationCategoryViewId = currentWorkspace?.operationCategoryViewId;
        
        // operationCategoryViewId: 0 -> Bağımsız (isHierarchic = false)
        // operationCategoryViewId: 1 -> Hiyerarşik (isHierarchic = true)
        if (operationCategoryViewId === 0) {
            return false; // Bağımsız mod
        }
        if (operationCategoryViewId === 1) {
            return true; // Hiyerarşik mod
        }
        
        // Fallback: eski isHierarchic alanı varsa onu kullan
        return currentWorkspace?.isHierarchic || false;
    },
    username(state) {
        return state.user.ntUsername;
    },
    userEmail(state) {
        return state.user.email;
    },
    userPhone(state) {
        return state.user.phone;
    },
    userFullName(state) {
        return state.user.fullName;
    },
    userToken(state) {
        return state.user.token;
    },
    isSuperUser(state) {
        return state.user.isSuper;
    },
    isDomainUser(state) {
        return state.user.isDomain;
    },
    otpToken(state) {
        return state.user.otpToken;
    },
    token(state) {
        return state.user.token;
    },
    isLoggedIn(state) {
        if (state.user.otpToken != null || state.user.otpToken != undefined) {
            return true;
        } else {
            return false;
        }
    },
    isAuthenticated(state) {
        if ((state.user.token != null || state.user.token != undefined) && (state.user.refreshToken != null || state.user.refreshToken != undefined) && (state.user.tokenExpiration != null || state.user.tokenExpiration != undefined)) {
            return true;
        } else {
            return false;
        }
    },
    isLoggedOut(state) {
        return state.user.autoLoggedOut;
    },
    languageId(state) {
        return state.user.languageId;
    },
    hasExpiredAccounts(state) {
        return state.user.hasExpiredAccounts;
    },
    expiredAccountsCount(state) {
        return state.user.expiredAccountsCount;
    },
    operationStatusIdle(state) {
        return state.user.operationStatusIdle;
    },
    operationStatusActive(state) {
        return state.user.operationStatusActive;
    },
    expiredAccounts(state) {
        return state.user.expiredAccounts;
    },
    passwordResetUser(state) {
        return state.user.passwordResetUser;
    },
    isPasswordResetProcess(state) {
        return state.user.canChangePassword;
    },
    isPasswordChanged(state) {
        return state.user.isPasswordChanged;
    },
    otpProcess(state) {
        return state.user.canProceedWithOtp;
    },
    tokenExpiration(state) {
        return state.user.tokenExpiration;
    },
    refreshTokenExpiration(state) {
        return state.user.refreshTokenExpiration;
    },
    isSessionEnding(state) {
        return state.user.isSessionEnding;
    },
    fireSessionNotification(state) {
        return state.user.fireSessionNotification;
    },
    remainingSessionTime(state) {
        return state.user.remainingSessionTime;
    },
    isScheduledReplyEnabled(state) {
        const currentWorkspace = state.user.registeredWorkspaces.find(x => x.isCurrentWorkspace);
        const workspaceFlag = currentWorkspace?.isScheduledReplyEnabled;

        if (workspaceFlag !== undefined && workspaceFlag !== null) {
            return !!workspaceFlag;
        }

        return !!state.user.isScheduledReplyEnabled;
    },
    operationQueueId(state) {
        return state.user.operationQueueId;
    }
}